import {
  formatDueInstant,
  formatMinutesAsDuration,
  formatPolicyMinutesRow,
} from '../../utils/complaintTatFormatter';

/**
 * Read-only complaint TAT summary for a location card (superadmin Locations page).
 */
function LocationComplaintTatCard({ tatState }) {
  if (!tatState || tatState.skip) {
    return null;
  }

  if (tatState.loading) {
    return (
      <div className="location-card-tat">
        <div className="location-card-tat-head">
          <span className="location-card-tat-title">Complaint TAT</span>
        </div>
        <p className="location-card-tat-muted">Loading…</p>
      </div>
    );
  }

  if (tatState.error) {
    return (
      <div className="location-card-tat">
        <div className="location-card-tat-head">
          <span className="location-card-tat-title">Complaint TAT</span>
        </div>
        <p className="location-card-tat-muted">Unable to load TAT policy</p>
      </div>
    );
  }

  const current = tatState.current;
  const next = tatState.next;

  if (!current) {
    return (
      <div className="location-card-tat location-card-tat--missing">
        <div className="location-card-tat-head">
          <span className="location-card-tat-title">Complaint TAT</span>
          <span className="location-card-tat-badge location-card-tat-badge--warn">Not configured</span>
        </div>
        <p className="location-card-tat-muted">
          Complaints cannot be logged until a policy is set under Settings → Complaint TAT.
        </p>
      </div>
    );
  }

  const rows = formatPolicyMinutesRow(current);

  return (
    <div className="location-card-tat">
      <div className="location-card-tat-head">
        <span className="location-card-tat-title">Complaint TAT</span>
        <span className="location-card-tat-badge location-card-tat-badge--ok">Active</span>
        {next && (
          <span className="location-card-tat-badge location-card-tat-badge--scheduled">
            Scheduled {formatDueInstant(next.effective_from)}
          </span>
        )}
      </div>
      <p className="location-card-tat-meta">
        Active since {formatDueInstant(current.effective_from)}
      </p>
      <table className="location-card-tat-table">
        <thead>
          <tr>
            <th>Severity</th>
            <th>Acknowledge</th>
            <th>Close</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.severity}>
              <td>{row.severity}</td>
              <td>{row.ack}</td>
              <td>{row.closure}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {next && (
        <p className="location-card-tat-scheduled-note">
          Next policy from {formatDueInstant(next.effective_from)} — Critical{' '}
          {formatMinutesAsDuration(next.critical_ack_minutes)} ack, Major{' '}
          {formatMinutesAsDuration(next.major_ack_minutes)} ack, Minor{' '}
          {formatMinutesAsDuration(next.minor_ack_minutes)} ack.
        </p>
      )}
    </div>
  );
}

export default LocationComplaintTatCard;
